import React, { FunctionComponent, useState, useEffect } from 'react';
import { Button, Grid, Box, Typography } from '@material-ui/core';
import ContinueButton from '../buttons/continueButton/ContinueButton';
import accessoriesStyles from './accessoriesStyles';
import Item from './item/Item';
import Translation from '../../../../common/components/presentation/Translation/Translation';
// import { useCheckSelectedFeatures } from '../../../../../../../../../../hooks/features/useCheckSelectedFeatures';
export interface DealData_accessories_attributes {
  __typename: 'AccessoriesData';
  picture: string;
  label: string;
  description: string | null;
}

const Accessories: FunctionComponent = () => {
  const styles = accessoriesStyles();
  const [mockSelectedAccessories, setMockSelectedAccessories] = useState([]);
  const [showMore, setShowMore] = useState(false);

  /* TODO: Replace the mockup accessory list with accessories coming from the back-end */
  interface MockItem {
    __typename: null;
    id: number;
    price: number;
    code: string;
    attributes: DealData_accessories_attributes;
  }

  const mockItems: MockItem[] = [
    // {
    //   id: 1,
    //   price: 300,
    //   code: '1',
    //   __typename: null,
    //   attributes: {
    //     __typename: null,
    //     picture: 'https://dxp-pim-proxy-staging.inchcapedigital.com/Media/media-files/9/2/7/e/927ef03022ee8f117611a75a59ec92e389944eba_Jaguar_Insurance.jpg/download',
    //     label: 'Side Steps',
    //     description: "",
    //   }
    // },
    // {
    //   id: 2,
    //   price: 300,
    //   code: '2',
    //   __typename: null,
    //   attributes: {
    //     __typename: null,
    //     picture: 'https://dxp-pim-proxy-staging.inchcapedigital.com/Media/media-files/f/9/b/3/f9b32891124002defc21aadad3260ced14d27271_Jaguar_Accessories.jpg/download',
    //     label: 'Pet Package',
    //     description: "",
    //   }
    // },
    // {
    //   id: 3,
    //   price: 300,
    //   __typename: null,
    //   code: '3',
    //   attributes: {
    //     __typename: null,
    //     picture: 'https://dxp-pim-proxy-staging.inchcapedigital.com/Media/media-files/5/1/e/8/51e8acbc551f6b4ca53bad786de9c06871a16084_Jaguar_Winter_wheels.jpg/download',
    //     label: 'Roof Rack',
    //     description: "",
    //   }
    // },
    // {
    //   id: 4,
    //   price: 300,
    //   __typename: null,
    //   code: '4',
    //   attributes: {
    //     __typename: null,
    //     picture: 'https://dxp-pim-proxy-staging.inchcapedigital.com/Media/media-files/5/1/e/8/51e8acbc551f6b4ca53bad786de9c06871a16084_Jaguar_Winter_wheels.jpg/download',
    //     label: 'Roof Rack',
    //     description: "",
    //   }
    // },
    // {
    //   id: 5,
    //   price: 300,
    //   code: '5',
    //   __typename: null,
    //   attributes: {
    //     __typename: null,
    //     picture: 'https://dxp-pim-proxy-staging.inchcapedigital.com/Media/media-files/f/9/b/3/f9b32891124002defc21aadad3260ced14d27271_Jaguar_Accessories.jpg/download',
    //     label: 'Pet Package',
    //     description: "",
    //   }
    // },
    // {
    //   id: 6,
    //   price: 300,
    //   code: '6',
    //   __typename: null,
    //   attributes: {
    //     __typename: null,
    //     picture: 'https://dxp-pim-proxy-staging.inchcapedigital.com/Media/media-files/f/9/b/3/f9b32891124002defc21aadad3260ced14d27271_Jaguar_Accessories.jpg/download',
    //     label: 'Pet Package',
    //     description: "",
    //   }
    // },
    // {
    //   id: 7,
    //   price: 300,
    //   code: '7',
    //   __typename: null,
    //   attributes: {
    //     __typename: null,
    //     picture: 'https://dxp-pim-proxy-staging.inchcapedigital.com/Media/media-files/f/9/b/3/f9b32891124002defc21aadad3260ced14d27271_Jaguar_Accessories.jpg/download',
    //     label: 'Pet Package',
    //     description: "",
    //   }
    // },
    // {
    //   id: 8,
    //   price: 300,
    //   code: '8',
    //   __typename: null,
    //   attributes: {
    //     __typename: null,
    //     picture: 'https://dxp-pim-proxy-staging.inchcapedigital.com/Media/media-files/f/9/b/3/f9b32891124002defc21aadad3260ced14d27271_Jaguar_Accessories.jpg/download',
    //     label: 'Pet Package',
    //     description: "",
    //   }
    // }
  ];

  useEffect(() => {
    if (mockItems.length > 4) {
      setShowMore(true);
    }
  }, []);

  const handleCheckboxChange = (accessory: number) => {
    // TODO: Using mock data set. Refactor when data from BE ready
    const isAccessoryExisting = mockSelectedAccessories.includes(accessory);

    if (!isAccessoryExisting) {
      setMockSelectedAccessories([...mockSelectedAccessories, accessory]);
    } else {
      setMockSelectedAccessories(mockSelectedAccessories.filter(i => i !== accessory));
    }
  };

  return (
    <Grid spacing={1} data-test={'checkout:accessories'}>
      <Box className={styles.container} data-test={'checkout:accessories:container'}>
        <Typography data-test={'checkout:accessories:description'}>
          <Translation id={'trans__checkout__next_step__accessories_section_message'} className={styles.description} />
        </Typography>
        <Grid container spacing={1} className={styles.itemsWrapper} data-test={'checkout:accessories:items'}>
          {mockItems?.length > 0 && (
            <>
              {mockItems.map((item, index) => (
                <Grid xs={6} sm={4} md={3} item key={item.code} className={showMore && index >= 4 ? styles.item : ''}>
                  <Item
                    item={item}
                    isChecked={mockSelectedAccessories?.includes(item.id)}
                    handleSelectedItem={() => handleCheckboxChange(item.id)}
                  />
                </Grid>
              ))}
            </>
          )}
        </Grid>
        {mockItems?.length > 4 && (
          <Box className={styles.buttonContainer}>
            <Button className={styles.button} onClick={() => setShowMore(!showMore)}>
              <Typography>
                {showMore ? (
                  <Translation id={'trans__checkout__next_step__accessories_show_more'} />
                ) : (
                  <Translation id={'trans__checkout__next_step__accessories_show_less'} />
                )}
              </Typography>
            </Button>
          </Box>
        )}
      </Box>
      <Box className={styles.continueButtonContainer}>
        <ContinueButton testId="checkout:continue_button:accesories" activateNextStep={true} />
      </Box>
    </Grid>
  );
};

export default Accessories;
